import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://fflabicuwrslttpsyewa.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZmbGFiaWN1d3JzbHR0cHN5ZXdhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQzMDQ2MDEsImV4cCI6MjA3OTg4MDYwMX0.Qy61nr-q-EOAKDrPflrKxCpguWlSHsDx1BEnwonkqU8';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage // Explicitly use localStorage
  },
});